import {Familienstand, Todesursache, Vormund} from "./enums";
import {Datum, Uhrzeit} from './types';

import {Person} from "./person";


/**
 * Personendaten des Verstorbenen.
 */
export class Verstorbener extends Person {

	//Sämtliche Personen-Daten über Person-Klasse eingebunden. Zusätzlich:
	familienstand: Familienstand;
	religion: string;
	staatsangehoerigkeit: string;
	krankenkasse: string;
	landkreis: string;
	vormund: Vormund;
	vormunddaten: string;

	//Geburts- und Sterbe-Daten
	geburtsstandesamt: string;
	sterbedatum: Datum;
	sterbezeit: Uhrzeit;
	todesursache: Todesursache;
	sterbeplatz: string;
	sterbeplz: string;
	sterbeort: string;
	sterbestrasse: string;
	sterbestandesamt: string;

}



// WEBPACK FOOTER //
// ./src/model/verstorbener.ts